import trasero from '../../static/autos/Atras.jpg';
import Camara from '../../static/autos/Camara.jpg';
import Chasis from '../../static/autos/Chassis.jpg';
import FaroDelanteroDerecho from '../../static/autos/FaroDelanteroDerecho.jpg';
import FaroDelanteroIzquierdo from '../../static/autos/FaroDelanteroIzquierdo.jpg';
import FaroTraseroDerecho from '../../static/autos/FaroTraseroDerecho.jpg';
import FaroTraseroIzquierdo from '../../static/autos/FaroTraseroIzquierdo.jpg';
import Frente from '../../static/autos/Frente.jpg';
import derecho from '../../static/autos/LadoDerecho.jpg';
import izquierdo from '../../static/autos/LadoIzquierdo.jpg';
import Motor from '../../static/autos/Motor.jpg';
import ParabrisasDelantero from '../../static/autos/ParabrisasDelantero.jpg';
import Radio from '../../static/autos/Radio.jpg';
import RetrovisorDerecho from '../../static/autos/RetrovisorDerecho.jpg';
import RetrovisorIzquierdo from '../../static/autos/RetrovisorIzquierdo.png';
import RuedaDeAuxilio from '../../static/autos/RuedaDeAuxilio.jpg';
import SeñaleroDerecho from '../../static/autos/SeñaleroDerecho.jpg';
import SeñaleroIzquierdo from '../../static/autos/SeñaleroIzquierdo.jpg';
import Tablero from '../../static/autos/Tablero.jpg';

export const cardEmpty = {
  item: '1',
  key: 1,
  parte: 'Extra',
  image: Camara,
  check: false
};

export const cardsGeneral = [
  {
    item: '1',
    key: 1,
    parte: 'Frente',
    image: Frente,
    check: false
  },
  {
    item: '2',
    key: 2,
    image: izquierdo,
    parte: 'Lateral Izquierdo / Conductor',
    check: false
  },
  {
    item: '3',
    key: 3,
    image: RetrovisorIzquierdo,
    parte: 'Espejo Retrovisor Izquierdo / Conductor',
    parteDescripcion: 'Foto del Lado Vidrio',
    check: false
  },
  {
    item: '4',
    key: 4,
    image: trasero,
    parte: 'Detrás',
    check: false
  },
  {
    item: '5',
    key: 5,
    parte: 'Lateral Derecho / Acompañante',
    image: derecho,
    check: false
  },
  {
    item: '6',
    key: 6,
    image: RetrovisorDerecho,
    parte: 'Espejo Retrovisor Derecho / Acompañante',
    parteDescripcion: 'Foto del Lado Vidrio',
    check: false
  },
  {
    item: '7',
    key: 7,
    image: Tablero,
    parte: 'Tablero',
    check: false
  },
  {
    item: '8',
    key: 8,
    image: Radio,
    parte: 'Radio',
    check: false
  },
  {
    item: '9',
    key: 9,
    image: ParabrisasDelantero,
    parte: 'Parabrisas Delantero',
    parteDescripcion: 'Foto desde Dentro del Vehículo',
    check: false
  },
  {
    item: '10',
    key: 10,
    image: Motor,
    parte: 'Motor',
    check: false
  },
  {
    item: '11',
    key: 11,
    image: Chasis,
    parte: 'Chasis',
    check: false
  },
  {
    item: '12',
    key: 12,
    image: RuedaDeAuxilio,
    parte: 'Rueda de Auxilio',
    check: false
  }
];

export const cards = [
  {
    item: '1',
    key: 1,
    parte: 'Frente',
    image: Frente,
    check: false
  },
  {
    item: '2',
    key: 2,
    image: izquierdo,
    parte: 'Lateral Izquierdo / Conductor',
    check: false
  },
  {
    item: '3',
    key: 3,
    image: RetrovisorIzquierdo,
    parte: 'Espejo Retrovisor Izquierdo / Conductor',
    parteDescripcion: 'Foto del Lado Vidrio',
    check: false
  },
  {
    item: '4',
    key: 4,
    image: trasero,
    parte: 'Detrás',
    check: false
  },
  {
    item: '5',
    key: 5,
    parte: 'Lateral Derecho / Acompañante',
    image: derecho,
    check: false
  },
  {
    item: '6',
    key: 6,
    image: RetrovisorDerecho,
    parte: 'Espejo Retrovisor Derecho / Acompañante',
    parteDescripcion: 'Foto del Lado Vidrio',
    check: false
  },
  {
    item: '7',
    key: 7,
    image: Tablero,
    parte: 'Tablero',
    check: false
  },
  {
    item: '8',
    key: 8,
    image: Radio,
    parte: 'Radio',
    check: false
  },
  {
    item: '9',
    key: 9,
    image: ParabrisasDelantero,
    parte: 'Parabrisas Delantero',
    parteDescripcion: 'Foto desde Dentro del Vehículo',
    check: false
  },
  {
    item: '10',
    key: 10,
    image: Motor,
    parte: 'Motor',
    check: false
  },
  {
    item: '11',
    key: 11,
    image: Chasis,
    parte: 'Chasis',
    check: false
  },
  {
    item: '12',
    key: 12,
    image: RuedaDeAuxilio,
    parte: 'Rueda de Auxilio',
    check: false
  },
  {
    item: '13',
    key: 13,
    image: FaroDelanteroDerecho,
    parte: 'Faro Delantero Derecho / Acompañante',
    check: false
  },
  {
    item: '14',
    key: 14,
    image: FaroDelanteroIzquierdo,
    parte: 'Faro Delantero Izquierdo / Conductor',
    check: false
  },
  {
    item: '15',
    key: 15,
    image: FaroTraseroDerecho,
    parte: 'Faro Trasero Derecho / Acompañante',
    check: false
  },
  {
    item: '16',
    key: 16,
    image: FaroTraseroIzquierdo,
    parte: 'Faro Trasero Izquierdo / Conductor',
    check: false
  },
  {
    item: '17',
    key: 17,
    image: SeñaleroDerecho,
    parte: 'Señalero Derecho / Acompañante',
    check: false
  },
  {
    item: '18',
    key: 18,
    image: SeñaleroIzquierdo,
    parte: 'Señalero Izquierdo / Conductor',
    check: false
  }
];
